import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Avatar,
  Divider,
  Stack,
  InputLabel,
  TextField,
  InputAdornment, 
  IconButton,
  Popover, 
  Typography,
} from "@mui/material";
import Visibility     from "@mui/icons-material/Visibility";
import VisibilityOff  from "@mui/icons-material/VisibilityOff";


export default function InputField({
  name,
  value,
  onChange,
  errorMsg,            // string | undefined
  type = "text",
 submitTick,
 isPasswordField,
 onClick, 
 showPassword
}) {
  const ref = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);

  // open pop-over whenever we have an error **and** we're not focused
  React.useEffect(() => {
    if (errorMsg && document.activeElement !== ref.current) {
      setAnchorEl(ref.current);
    } else {
      setAnchorEl(null);
    }
  }, [errorMsg,submitTick]);

  return (
    <>
    <TextField
  id={name}
  type={isPasswordField && !showPassword ? "password" : "text"}
  size="small"
  fullWidth
  value={value}
  onChange={onChange}
  error={Boolean(errorMsg)}
  inputRef={ref}
  onFocus={() => setAnchorEl(null)}
  InputLabelProps={{ shrink: false }}

  /* 1️⃣  your style rules stay in `sx` */
  sx={{
    backgroundColor: "#FAFCFC",
    "& .MuiOutlinedInput-root": {
      fontSize: "16.5px",
      fontFamily: "'Lato', sans-serif",
      color: "#49768C",
      fontWeight: 700,
      "& fieldset":        { borderColor: "#C5D3DD" },
      "&:hover fieldset":  { borderColor: "#AABFCC" },
      "&.Mui-focused fieldset": { borderColor: "#49768C" },
    },
  }}

  /* 2️⃣  put the adornment in `InputProps` (not `sx`) */
  InputProps={{
    endAdornment: isPasswordField && (
      <InputAdornment position="end" sx={{ mr: 0.5 }}>
        <IconButton
          edge="end"
          size="small"
          onClick={onClick}
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        disableAutoFocus
        disableEnforceFocus
        sx={{ pointerEvents: "none" }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        PaperProps={{
          sx: {
            bgcolor: "#AA5869",
            color: "#fff",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            fontSize: 12,
            maxWidth: 260,
          },
        }}
      >
        <Typography variant="caption">{errorMsg}</Typography>
      </Popover>
    </>
  );
}